import MobileScrollers from '../components/MobileScrollers';
import PriceManager from '../components/PriceManager';

export default class Testimonials extends MobileScrollers {
  constructor(container) {
    super(container);
    this.priceManager = new PriceManager(this.el);
    this.priceManager.updateAll();

    const cellAlign = this.el.querySelectorAll('.testimonial').length > 2
      ? 'left'
      : 'center';

    this.init('[data-testimonials]', {
      cellAlign,
    });
  }
}
